import React from 'react';
import { Line } from 'react-chartjs-2';
import { Col, Row, Typography } from 'antd';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

const { Title } = Typography;

const LineChart = ({ coinHistory, currentPrice, coinName }) => {
    const coinPrice = [];
    const coinTimestamp = [];

    for (let i = 0; i < coinHistory?.data?.history?.length; i += 1) {
        coinPrice.push(coinHistory?.data?.history[i].price);
        coinTimestamp.push(new Date(coinHistory?.data?.history[i].timestamp).toLocaleDateString());
    }

    const data = {
        labels: coinTimestamp,
        datasets: [
            {
                label: 'Price In USD',
                data: coinPrice,
                fill: false,
                backgroundColor: '#ff4d4d',
                borderColor: '#ff4d4d',
            },
        ],
    };

    const options = {
        scales: {
            x: {
                ticks: {
                    color: '#ffffff',
                },
                grid: {
                    color: '#444',
                },
            },
            y: {
                ticks: {
                    color: '#ffffff',
                },
                grid: {
                    color: '#444',
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    color: '#ffffff',
                },
            },
        },
        elements: {
            point: {
                backgroundColor: '#ff4d4d',
            },
        },
    };

    const containerStyle = {
        backgroundColor: '#000',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    };

    const titleStyle = {
        color: '#ffffff',
        marginBottom: '1rem',
    };

    const priceContainerStyle = {
        marginBottom: '2rem',
        color: '#ffffff',
    };

    const priceChangeStyle = {
        color: '#ff4d4d',
    };

    const currentPriceStyle = {
        color: '#ffffff',
    };

    return (
        <div style={containerStyle}>
            <Row className="chart-header">
                <Title level={2} style={titleStyle}>{coinName} Price Chart</Title>
                <Col className="price-container" style={priceContainerStyle}>
                    <Title level={5} style={priceChangeStyle}>Change: {coinHistory?.data?.change}%</Title>
                    <Title level={5} style={currentPriceStyle}>Current {coinName} Price: ${currentPrice}</Title>
                </Col>
            </Row>
            <Line data={data} options={options} />
        </div>
    );
};

export default LineChart;
